import React from 'react';
import { DisappearedLoading } from 'react-loadingg';

const CpBaseLoading = () => {
  return <DisappearedLoading color="#DB6E20" size="Large" />;
};

export default CpBaseLoading;
